const settings = (permissions, role = null) => ({
	pages: {
		id: 'pages',
		text: 'Settings',
		icon: 'Extension',
	},
	singlePages: {
		id: 'settingsPage',
		text: 'Settings',
		path: 'settings',
		icon: 'SettingsApplications',
		subMenu: {

			user: {
				id: 'users',
				text: 'User',
				path: 'settings/users?page=1&limit=20',
				icon: 'AccountCircle',
				hide: role !== 1,
			},
			role: {
				id: 'roles',
				text: 'Role',
				path: 'settings/roles',
				icon: 'Lock',
				hide: role !== 1,
			},
			country: {
				id: 'country',
				text: 'Country',
				path: 'settings/countries?page=1&limit=20',
				icon: 'AddLocation',
				hide: !permissions?.['manage country'],
			},
			state: {
				id: 'state',
				text: 'State',
				path: 'settings/states?page=1&limit=20',
				icon: 'AddLocation',
				hide: !permissions?.['manage state'],
			},
			city: {
				id: 'city',
				text: 'City',
				path: 'settings/cities?page=1&limit=20',
				icon: 'AddLocation',
				hide: !permissions?.['manage city'],
			},
			location: {
				id: 'location',
				text: 'Yard',
				path: 'settings/locations?page=1&limit=20',
				icon: 'AddLocation',
				hide: !permissions?.['manage location'],
			},
			ports: {
				id: 'ports',
				text: 'Port',
				path: 'settings/ports?page=1&limit=20',
				icon: 'AddLocation',
				hide: !permissions?.['manage port'],
			},
			titleType: {
				id: 'titleType',
				text: 'Title Type',
				path: 'settings/title-types?page=1&limit=20',
				icon: 'AddLocation',
				hide: !permissions?.['manage title type'],
			},
			subscriptionPackage: {
				id: 'subscriptionPackage',
				text: 'Subscription Package',
				path: 'settings/subscription-packages?page=1&limit=20',
				icon: 'InsertDriveFile',
				hide: !permissions?.['manage subscription package'],
			},
			systemSetting: {
				id: 'systemSetting',
				text: 'System Setting',
				path: 'settings/system-setting',
				icon: 'SettingsApplications',
				hide: !permissions?.['manage system settings'],
			},
			auditLog: {
				id: 'auditLog',
				text: 'Audit Log',
				path: 'settings/audit-logs?page=1&limit=20',
				icon: 'History',
				hide: !permissions?.['manage audit log'],
			},
		},
	},
});

const sheets = {
	singlePages: {
		id: 'sheetPage',
		text: 'Sheets',
		path: 'sheets?page=1&limit=20',
		icon: 'InsertDriveFile',
		subMenu: null,
	},
};

const buyerNumberCustomer = {
	singlePages: {
		id: 'buyerNumberCustomerPage',
		text: 'Buyer Numbers',
		path: 'customer-buyer-numbers?page=1&limit=20',
		icon: 'InsertDriveFile',
		subMenu: null,
	},
};

export const shippingCalculate = {
	singlePages: {
		id: 'shippingCalculate',
		text: 'Shipping Calculator',
		path: 'shipping-calculate',
		icon: 'InsertDriveFile',
		subMenu: null,
	},
};

const weights = {
	singlePages: {
		id: 'weightPage',
		text: 'Weights',
		path: 'weights?page=1&limit=20',
		icon: 'InsertDriveFile',
		subMenu: null,
	},
};

// const accounts = (permissions, user) => ({
// 	pages: {
// 		id: 'accountspages',
// 		text: 'Accounting',
// 		icon: 'Calculate',
// 	},
// 	singlePages: {
// 		id: 'accountsPage',
// 		text: 'Accounting',
// 		path: 'accounts',
// 		icon: 'Calculate',
// 		subMenu: {
// 			vehicleInvoice: {
// 				id: 'vehicle-invoice',
// 				text: 'Vehicle Invoice',
// 				path: 'accounts/vehicle-invoice?page=1&limit=20',
// 				icon: 'Inventory',
// 				hide: !permissions?.['invoices.vehicle_invoice'],
// 			},

// 			serviceInvoice: {
// 				id: 'service-invoice',
// 				text: 'Service Invoice',
// 				path: 'accounts/service-invoice?page=1&limit=20',
// 				icon: 'Inventory',
// 				hide: !permissions?.['invoices.service_invoice'],
// 			},

// 			vehicleAccounting: {
// 				id: 'vehicle-ccounting',
// 				text: 'Vehicle',
// 				icon: 'Inventory',
// 				hide: !permissions?.['accounting.vehicle'],
// 				new_tab_open: `${_vehicleAccountingBaseUrl}/auth/guest/login/${user?.id}`,
// 			},

// 			serviceAccounting: {
// 				id: 'service-ccounting',
// 				text: 'Service',
// 				icon: 'Inventory',
// 				hide: !permissions?.['accounting.service'],
// 				new_tab_open: `${_serviceAccountingBaseUrl}/auth/guest/login/${user?.id}`,
// 			},
// 		},
// 	},
// });

const accounts = (permissions) => ({
	pages: {
		id: 'accountspages',
		text: 'Accounting',
		icon: 'Calculate',
	},
	singlePages: {
		id: 'accountsPage',
		text: 'Accounting',
		path: 'accounts',
		icon: 'Calculate',
		subMenu: {
			InvoiceSummery: {
				id: 'invoice',
				text: 'Invoice Summary',
				path: 'accounts/invoice-summary?page=1&limit=20',
				icon: 'Inventory',
				hide: !permissions?.['invoices.index'],
			},
			PaidInvoice: {
				id: 'paidInvoice',
				text: 'Paid Invoice',
				path: 'accounts/paid-invoice?page=1&limit=20',
				icon: 'Paid',
				hide: !permissions?.['invoices.paid_invoice'],
			},
			PartialPaidInvoice: {
				id: 'partialPaidInvoice',
				text: 'Partial Paid Invoice',
				path: 'accounts/invoices/partially-paid?page=1&limit=20',
				icon: 'Palette',
				hide: !permissions?.['invoices.partially_paid_invoice'],
			},
			UnpaidInvoice: {
				id: 'unpaidInvoice',
				text: 'Unpaid Invoice',
				path: 'accounts/invoices/unpaid?page=1&limit=20',
				icon: 'Unpublished',
				hide: !permissions?.['invoices.unpaid_invoice'],
			},
		},
	},
});

const vehicle = (permissions) => ({
	singlePages: {
		id: 'vehicle',
		text: 'Vehicles',
		path: 'vehicles?page=1&limit=20',
		icon: 'DirectionsCar',
		hide: !permissions?.['manage vehicle'],
		subMenu: {
			allVehicle: {
				id: 'allVehicle',
				text: 'All Vehicle',
				path: 'vehicles?page=1&limit=20',
				icon: 'FiberManualRecord',
				hide: !permissions?.['manage vehicle'],
			},
			newPurchased: {
				id: 'newPurchased',
				text: 'New Purchased',
				path: 'new-purchased-vehicles?page=1&limit=20&status_id=10',
				icon: 'FiberManualRecord',
				hide: !permissions?.['manage vehicle'],
			},
			paid: {
				id: 'paid',
				text: 'Paid',
				path: 'paid-vehicles?page=1&limit=20&status_id=15',
				icon: 'FiberManualRecord',
				hide: !permissions?.['manage vehicle'],
			},
			dispatched: {
				id: 'dispatched',
				text: 'Dispatched',
				path: 'dispatched-vehicles?page=1&limit=20&status_id=20',
				icon: 'FiberManualRecord',
				hide: !permissions?.['manage vehicle'],
			},
			pickedUp: {
				id: 'pickedUp',
				text: 'Picked Up',
				path: 'pickedup-vehicles?page=1&limit=20&status_id=25',
				icon: 'FiberManualRecord',
				hide: !permissions?.['manage vehicle'],
			},

			onHand: {
				id: 'onHand',
				text: 'On Hand',
				path: 'onhand-vehicles?page=1&limit=20&status_id=30',
				icon: 'FiberManualRecord',
				hide: !permissions?.['manage vehicle'],
			},
			loaded: {
				id: 'loaded',
				text: 'Loaded',
				path: 'loaded-vehicles?page=1&limit=20&status_id=50',
				icon: 'FiberManualRecord',
				hide: !permissions?.['manage vehicle'],
			},
			onTheWay: {
				id: 'onTheWay',
				text: 'On the Way',
				path: 'ontheway-vehicles?page=1&limit=20&status_id=60',
				icon: 'FiberManualRecord',
				hide: !permissions?.['manage vehicle'],
			},
			arrived: {
				id: 'arrived',
				text: 'Arrived',
				path: 'arrived-vehicles?page=1&limit=20&status_id=70',
				icon: 'FiberManualRecord',
				hide: !permissions?.['manage vehicle'],
			},
			handedOver: {
				id: 'handedOver',
				text: 'Handed Over',
				path: 'handed-over-vehicles?page=1&limit=20&status_id=80',
				icon: 'FiberManualRecord',
				hide: !permissions?.['manage vehicle'],
			},
		},
	},
});

const exports = (permissions) => ({
	singlePages: {
		id: 'export',
		text: 'Export',
		path: 'exports?page=1&limit=20',
		icon: 'ImportExport',
		subMenu: null,
		hide: !permissions?.['manage container'],
	},
});

const damageClaim = (permissions) => ({
	singlePages: {
		id: 'damageClaim',
		text: 'Damage Claim',
		path: 'damage-claims?page=1&limit=20',
		icon: 'DirectionsCar',
		subMenu: null,
		hide: !permissions?.['manage damage claim'],
	},
});

const vcc = (permissions) => ({
	singlePages: {
		id: 'vcc',
		text: 'VCC',
		path: 'vccs',
		icon: 'Feed',
		subMenu: null,
		hide: !permissions?.['manage vcc'],
	},
});

const consignee = (permissions) => ({
	singlePages: {
		id: 'consignee',
		text: 'Consignee',
		path: 'consignees?page=1&limit=20',
		icon: 'LocationCity',
		subMenu: null,
		hide: !permissions?.['manage consignee'],
	},
});

const carfax = (permissions) => ({
	singlePages: {
		id: 'carfax',
		text: 'CarFax',
		path: 'carfax?page=1&limit=20',
		icon: 'CarRental',
		subMenu: null,
		hide: !permissions?.['manage car fax'],
	},
});

const profiles = () => ({
	singlePages: {
		id: 'profilePage',
		text: 'Profiles',
		path: 'profiles',
		icon: 'Quickreply',
		subMenu: null,
		// hide: !permissions?.['faq.index'],
	},
});

const customers = (permissions) => ({
	singlePages: {
		id: 'customers',
		text: 'Customers',
		path: 'customers?page=1&limit=20',
		icon: 'AccountCircle',
		subMenu: null,
		hide: !permissions?.['manage customer'],
	},
});

const subuser = () => ({
	singlePages: {
		id: 'subuser',
		text: 'Subuser',
		path: 'sub-users?page=1&limit=20',
		icon: 'Customers',
		subMenu: null,
		hide: false,
	},
});

const containers = (permissions) => ({
	singlePages: {
		id: 'containersPage',
		text: 'Containers',
		path: 'containers?page=1&limit=20',
		icon: 'LocalShipping',
		subMenu: null,
		hide: !permissions?.['manage container'],
	},
});

const gatepass = () => ({
	singlePages: {
		id: 'gatepassPage',
		text: 'Gate Pass',
		path: 'gate-pass?page=1&limit=20',
		icon: 'CalendarViewWeek',
		subMenu: null,
		hide: false,
	},
});
const subUsers = () => ({
	singlePages: {
		id: 'subusers',
		text: 'Sub Users',
		path: 'sub-users?page=1&limit=20',
		icon: 'SupervisedUserCircle',
		subMenu: null,
		hide: false,
	},
});

const complains = (permissions) => ({
	singlePages: {
		id: 'complainsPage',
		text: 'Complain',
		path: 'complains?page=1&limit=20',
		icon: 'Chat',
		subMenu: null,
		hide: !permissions?.['manage complain'],
	},
});

// const price = (permissions) => ({
// 	singlePages: {
// 		id: 'price',
// 		text: 'Prices',
// 		path: 'prices?page=1&limit=20',
// 		icon: 'AlignVerticalBottom',
// 		hide: !permissions?.['prices.index'],
// 	},
// });

const pricing = (permissions) => {
	// eslint-disable-next-line prettier/prettier
	const hasPricingMenuPermissions =
		permissions?.['manage towing rate'] ||
		permissions?.['manage shipping rate'] ||
		permissions?.['manage clearance rate'] ||
		permissions?.['shipping price'] ||
		permissions?.['pricing pdf'] ||
		permissions?.['manage export rate'];
	// eslint-disable-next-line prettier/prettier
	return {
		singlePages: {
			id: 'pricingPage',
			text: 'Pricing',
			path: 'pricing',
			icon: 'ProductionQuantityLimits',
			hide: !hasPricingMenuPermissions,
			subMenu: {
				// towingingRate: {
				// 	id: 'towing',
				// 	text: 'Towing Rate',
				// 	path: 'towing-rates?page=1&limit=20',
				// 	icon: 'RateReview',
				// 	hide: !permissions?.['manage towing rate'],
				// },
				// shippingRate: {
				// 	id: 'shippingRate',
				// 	text: 'Shipping Rate',
				// 	path: 'shipping-rates?page=1&limit=20',
				// 	icon: 'AlignVerticalBottom',
				// 	hide: !permissions?.['manage shipping rate'],
				// },

				// getPrice: {
				// 	id: 'getPrice',
				// 	text: 'Price Inquiry',
				// 	path: 'price-inquiry',
				// 	icon: 'AttachMoney',
				// 	hide: !permissions?.['prices.index'],
				// },
				// shippingPricePerVehicle: {
				// 	id: 'shippingPricePerVehicle',
				// 	text: 'Generate Pricing',
				// 	path: 'shipping-prices',
				// 	icon: 'AttachMoney',
				// 	hide: !permissions?.['shipping price'],
				// },
				customerPricing: {
					id: 'customerPricing',
					text: 'Shipping Price',
					path: 'import-prices',
					icon: 'AttachMoney',
					hide: !permissions?.['pricing pdf'],
				},
				exportPricing: {
					id: 'exportPricing',
					text: 'Export Price',
					path: 'export-prices',
					icon: 'AttachMoney',
					hide: !permissions?.['pricing pdf'],
				},
				importRate: {
					id: 'importRate',
					text: 'Import Rate',
					path: 'import-rate',
					icon: 'AttachMoney',
					hide: !permissions?.['manage import rate'],
				},
				exportRate: {
					id: 'exportRate',
					text: 'Export Rate',
					path: 'export-rate',
					icon: 'AttachMoney',
					hide: !permissions?.['manage export rate'],
				},

			},
		},
	};
};

const accounting = () => ({
	singlePages: {
		id: 'accountingPage',
		text: 'Accounting',
		path: 'accounting',
		icon: 'AccountBalance',
		hide: false,
		subMenu: {
			towingingRate: {
				id: 'vehicle_invoice',
				text: 'Vehicle Invoice',
				path: 'vehicle-invoice?page=1&limit=20',
				icon: 'AccountBalanceWallet',
				hide: false,
			},
			shippingRate: {
				id: 'shipping_invoice',
				text: 'Shipping Invoice',
				path: 'service-invoice?page=1&limit=20',
				icon: 'AccountBalanceWallet',
				hide: false,
			},
			// advancePayment: {
			// 	id: 'advancePayment',
			// 	text: 'Advance Payment',
			// 	path: url,
			// 	icon: 'AccountBalanceWallet',
			// 	hide: false,
			// },
			invoiceVoucher: {
				id: 'invoiceVoucher',
				text: 'Invoice Voucher',
				path: 'customer-invoice-vouchers?page=1&limit=20',
				icon: 'AccountBalanceWallet',
				hide: false,
			},
			advancedVoucher: {
				id: 'advancedVoucher',
				text: 'Advanced Voucher',
				path: 'customer-advance-vouchers?page=1&limit=20',
				icon: 'AccountBalanceWallet',
				hide: false,
			},
		},
	},
});

const loadPlan = (permissions) => ({
	singlePages: {
		id: 'loadPlan',
		text: 'Load Plan',
		path: 'load-plans?page=1&limit=20',
		icon: 'NextPlan',
		subMenu: null,
		hide: !permissions?.['load-plans.index'],
	},
});

export {
	accounting,
	accounts,
	buyerNumberCustomer,
	complains,
	consignee,
	containers,
	customers,
	damageClaim,
	exports,
	gatepass,
	loadPlan,
	pricing,
	profiles,
	settings,
	sheets,
	subuser,
	subUsers,
	vcc,
	vehicle,
	weights,
	carfax,
};
